var map = {
	"./cn": 205,
	"./cn.json": 205,
	"./cs": 206,
	"./cs.json": 206,
	"./de": 207,
	"./de.json": 207,
	"./dk": 208,
	"./dk.json": 208,
	"./el": 209,
	"./el.json": 209,
	"./en": 210,
	"./en.json": 210,
	"./es": 211,
	"./es.json": 211,
	"./fr": 212,
	"./fr.json": 212,
	"./hi": 213,
	"./hi.json": 213,
	"./hr": 214,
	"./hr.json": 214,
	"./hu": 215,
	"./hu.json": 215,
	"./it": 216,
	"./it.json": 216,
	"./kk": 217,
	"./kk.json": 217,
	"./locales": 106,
	"./locales.ts": 106,
	"./lv": 218,
	"./lv.json": 218,
	"./nb": 219,
	"./nb.json": 219,
	"./pl": 220,
	"./pl.json": 220,
	"./pt": 221,
	"./pt.json": 221,
	"./ro": 222,
	"./ro.json": 222,
	"./ru": 223,
	"./ru.json": 223,
	"./tr": 224,
	"./tr.json": 224,
	"./tw": 225,
	"./tw.json": 225,
	"./uk": 226,
	"./uk.json": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;